import { MIN_Y, MAX_HEIGHT } from "../constants.js";
import { ellipseWeight, visit, writeHeight } from "./mask.js";

function clampHeight(height) {
    return Math.max(MIN_Y, Math.min(MAX_HEIGHT, Math.round(height)));
}

export default function applyValley(heights, resolution, layoutSize, feature, noise) {
    const strength = feature.strength ?? 1;

    visit(feature, resolution, layoutSize, (idx, u, v) => {
        const weight = ellipseWeight(u, v, noise, feature.seed);
        if (weight <= 0) return;

        const bowl = Math.max(0, 1 - (u * u * 0.65 + v * v));
        writeHeight(heights, idx, clampHeight(heights[idx] - feature.height * bowl * bowl * weight * strength));
    });
}
